import { MutationTree } from 'vuex';
import {
  GroupConditionObj,
  State,
  TagFormData
} from '@/store/modules/alertV2/tagGrouping/tagGrouping.store';
import {
  MultiSelectFieldOption,
  TagFormFieldOptions,
  TagTableInfo
} from '@/store/modules/alertV2/tagGrouping/interfaces';
import { tagAggTimeDefault } from '@/components/AlertsV2/tag-grouping/tags.types';
import { ALL } from '@/components/AlertsV2/tag-grouping/tags.constants';
import _ from 'lodash';
import { initialState } from '@/store/modules/alertV2/tagGrouping/tagGrouping.store';

interface TagConditionObjType {
  index: number;
  field: string;
  value: any;
}

interface TagFieldInfoType {
  field: string;
  value: any;
}

const mutations: MutationTree<State> = {
  setIsTagFormOpened(state: State, data: boolean) {
    state.isTagFormOpened = data;
  },
  setIsTagFormEdit(state: State, data: boolean) {
    state.isTagFormEdit = data;
  },
  setTagConditionObjValues(state: State, data: TagConditionObjType) {
    state.tagFormData.tagGroupNameInfo.groupingConditions[data.index][
      data.field
    ] = data.value;
  },
  resetTagConditionalObjValues(state: State) {
    state.tagFormData.tagGroupNameInfo.groupingConditions = [
      { isAnd: true, value1: '', value2: '', isValid: true }
    ];
  },
  addObjToGroupingConditions(state: State) {
    if (
      state.tagFormData.tagGroupNameInfo.groupingConditions.length >
      state.tagFormFieldOptions.noOfGroupsToBeCreated - 1
    )
      return;
    state.tagFormData.tagGroupNameInfo.groupingConditions.push({
      isAnd: true,
      value1: '',
      value2: '',
      isValid: true
    });
  },
  removeObjFromGropingConditions(state: State, index: number) {
    state.tagFormData.tagGroupNameInfo.groupingConditions.length > 1 &&
      state.tagFormData.tagGroupNameInfo.groupingConditions.splice(index, 1);
  },
  setTagGroupNameInfoFields(state: State, data: TagFieldInfoType) {
    state.tagFormData.tagGroupNameInfo[data.field] = data.value;
  },
  setTagTableInfo(state: State, data: TagTableInfo) {
    state.tagTableInfo = data;
  },
  setTagTimeFrameInfoFields(state: State, data: TagFieldInfoType) {
    state.tagFormData.timeFrameInfo[data.field] = data.value;
  },
  setTagNotificationInfoFields(state: State, data: TagFieldInfoType) {
    state.tagFormData.notificationInfo[data.field] = data.value;
  },
  clearTagPageField(state: State, pageKey: string) {
    if (pageKey === 'tagGroupNameInfo' || pageKey === 'ALL') {
      state.tagFormData.tagGroupNameInfo.groupingConditions = [
        { isAnd: true, value1: '', value2: '', isValid: true }
      ];
      state.tagFormData.tagGroupNameInfo.groupName = '';
      state.tagFormData.tagGroupNameInfo.groupingCondition = ALL;
      state.tagFormData.tagGroupNameInfo.groupingLabeledKeyExpression = '';
      state.tagFormData.formUtils.isCustomExpValid = false;
      state.tagFormData.formUtils.groupNameErrMsg = '';
    }
    if (pageKey === 'timeFrameInfo' || pageKey === 'ALL') {
      state.tagFormData.timeFrameInfo.notificationText = '';
      state.tagFormData.timeFrameInfo.aggTime = tagAggTimeDefault;
    }
    if (pageKey === 'notificationInfo' || pageKey === 'ALL') {
      state.tagFormData.notificationInfo.channels = [];
      state.tagFormFieldOptions.channelOptions = state.tagFormFieldOptions.channelOptions.map(
        obj => {
          obj.selected = false;
          return obj;
        }
      );
      state.tagFormData.notificationInfo.priority = '';
    }
  },
  resetTagPageField(state: State, pageKey: string) {
    state.tagFormData[pageKey] = _.cloneDeep(state.tagFormEditInitData[pageKey]);
  },
  setTagFormFieldOptions(state: State, data: TagFormFieldOptions) {
    state.tagFormFieldOptions = data;
  },
  setTagformChannelOptions(state: State, data: Array<MultiSelectFieldOption>) {
    state.tagFormFieldOptions.channelOptions = data;
  },
  setTagFormUtils(state: State, data: TagFieldInfoType) {
    state.tagFormData.formUtils[data.field] = data.value;
  },
  setTagFormData(state: State, data: TagFormData) {
    state.tagFormData = data;
  },
  setTagFormEditInitData(state: State, data: TagFormData) {
    state.tagFormEditInitData = data;
  },
  setDefaultValues(state: State) {
    Object.assign(state, { ...initialState });
  },
};

export default mutations;
